var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import routeUpdateReducer from "@ane/core/lib/services/syncUrlAndStore/RouteUpdateReducer";
import "./views/ComputeList/ducks/index.js";
import { reducer as reducer$2 } from "./views/ComputeList/ducks/ComputeDelete.ducks.js";
import { combineReducers } from "redux";
import { ComputeListReducer } from "./views/ComputeList/ducks/ComputeListFilter.ducks.js";
import { reducer } from "./views/ComputeDetail/ducks/ComputeDetail.ducks.js";
import { getComputeReducer } from "./ducks/GetCompute.ducks.js";
import { getComputeListReducer } from "./ducks/GetComputeList.ducks.js";
import { deleteComputeReducer } from "./ducks/DeleteCompute.ducks.js";
import { putComputeReducer } from "./ducks/PutCompute.ducks.js";
import "./views/ComputeCreate/ducks/ComputeCreate.ducks.js";
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import UserAccessReducersMapObject from "@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer";
import { ctmApi } from "@ane/exp-data/lib/redux/rtkquery";
import { computeCreateReducer } from "./views/ComputeCreate/components/ComputeCreateContainer/ComputeCreateContainer.ducks.js";
import { reducer as reducer$1 } from "./views/ComputeList/ducks/ComputeList.ducks.js";
const moduleReducer = __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, routeUpdateReducer), currentUserDetailsReducersMapObject), getWorkspaceReducersMapObject), UserAccessReducersMapObject), {
  computeManagementSystemModule: combineReducers({
    computeDetail: reducer,
    computeCreate: computeCreateReducer,
    computeListState: ComputeListReducer,
    computeList: reducer$1,
    computeDelete: reducer$2,
    unifiedComputeDetail: getComputeReducer,
    unifiedComputeDetailList: getComputeListReducer,
    unifiedComputeDelete: deleteComputeReducer,
    unifiedComputePut: putComputeReducer,
    [ctmApi.reducerPath]: ctmApi.reducer
  })
});
export {
  moduleReducer as default,
  moduleReducer
};
//# sourceMappingURL=reducers.js.map
